import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

const ADMIN_TOKEN_KEY = "summit-admin-token";

export const getAdminToken = () => {
  try { return localStorage.getItem(ADMIN_TOKEN_KEY); } catch { return null; }
};

export const setAdminToken = (token) => {
  try {
    if (token) localStorage.setItem(ADMIN_TOKEN_KEY, token);
    else localStorage.removeItem(ADMIN_TOKEN_KEY);
  } catch {
    // ignore
  }
};

// Attach admin Bearer token for any /admin/* request
api.interceptors.request.use((config) => {
  if (config.url && config.url.includes("/admin")) {
    const token = getAdminToken();
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

export const fetchProducts = async () => {
  const { data } = await api.get("/products");
  return data;
};

export const fetchProduct = async (id) => {
  const { data } = await api.get(`/products/${id}`);
  return data;
};

export const createCheckoutSession = async ({ items, email, promo_code }) => {
  const { data } = await api.post("/checkout/session", {
    items,
    origin_url: window.location.origin,
    email: email || null,
    promo_code: promo_code || null,
  });
  return data;
};

export const validatePromoCode = async (code) => {
  const { data } = await api.get("/promo/validate", { params: { code } });
  return data;
};

export const getCheckoutStatus = async (sessionId) => {
  const { data } = await api.get(`/checkout/status/${sessionId}`);
  return data;
};

export const submitContact = async (payload) => {
  const { data } = await api.post("/contact", payload);
  return data;
};

// ===== Admin =====
export const adminLogin = async ({ email, password }) => {
  const { data } = await api.post("/admin/login", { email, password });
  return data;
};

export const adminMe = async () => {
  const { data } = await api.get("/admin/me");
  return data;
};

export const adminFetchOrders = async () => {
  const { data } = await api.get("/admin/orders");
  return data;
};

export const adminFetchContacts = async () => {
  const { data } = await api.get("/admin/contacts");
  return data;
};

export const adminFetchSummary = async () => {
  const { data } = await api.get("/admin/summary");
  return data;
};

export const adminMarkShipped = async (orderId) => {
  const { data } = await api.patch(`/admin/orders/${orderId}/ship`);
  return data;
};

export const adminUnmarkShipped = async (orderId) => {
  const { data } = await api.patch(`/admin/orders/${orderId}/unship`);
  return data;
};

export const adminMarkMessageRead = async (messageId) => {
  const { data } = await api.patch(`/admin/contacts/${messageId}/read`);
  return data;
};
